import { AuthProvider, PermissionProvider } from "@niutraan/hooks";
import { initializeApiClient } from "@niutraan/hooks/src/lib/api";
import { QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import { ThemeProvider } from "./components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { queryClient } from "./lib/queryClient";
import { WebStorage } from "./lib/web";
import Routes from "./routes";

const apiUrl = `${import.meta.env.VITE_API_URL}/api`;
initializeApiClient(apiUrl, WebStorage);

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="niutraan-theme">
      <QueryClientProvider client={queryClient}>
        <AuthProvider
          config={{
            storage: WebStorage,
            apiUrl,
          }}
        >
          <PermissionProvider>
            <Routes />
            <Toaster />
          </PermissionProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
